import {t} from "i18next";
import {CheckOutlined, CloseOutlined, FieldTimeOutlined} from "@ant-design/icons";
import {Tooltip} from "antd";

function StateGroupItem({id, text, color, showText, showColor})
{

    const getIcon = () => {
        if(id === 1)
            return <FieldTimeOutlined />
        else if(id === 2)
            return <CheckOutlined />
        else if(id === 3)
            return <CloseOutlined />

        return <FieldTimeOutlined />
    }

    return (
        <Tooltip title={t(text)}>
            <div style={{display: 'flex', alignItems: 'center', gap: 6}}>
                {showColor && <div style={{width: 16, height: 16, backgroundColor: color, border: '1px solid black'}} />}
                {getIcon()}
                {showText && t(text)}
            </div>
        </Tooltip>
    )
}

function StateItem({text, color, showText, showColor})
{

    return (
        <Tooltip title={t(text)}>
            <div style={{display: 'flex', alignItems: 'center', gap: 6}}>
                {showColor && <div style={{width: 16, height: 16, backgroundColor: color, border: '1px solid black'}} />}
                {showText && t(text)}
            </div>
        </Tooltip>
    )
}

export {StateGroupItem, StateItem}
